import { render, staticRenderFns } from "./VInteractiveMedia.vue?vue&type=template&id=9d123d4a&scoped=true&"
import script from "./VInteractiveMedia.vue?vue&type=script&lang=js&"
export * from "./VInteractiveMedia.vue?vue&type=script&lang=js&"
import style0 from "./VInteractiveMedia.vue?vue&type=style&index=0&id=9d123d4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d123d4a",
  null
  
)

export default component.exports